import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-slate-50 text-slate-800">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-extrabold mb-2 text-blue-900">Conditions d'Utilisation</h1>
        <p className="text-slate-500 mb-8">Entrée en vigueur : 4 janvier 2026</p>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 space-y-6">
            
            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">1. Acceptation</h2>
                <p>
                    En accédant à <strong>Forfeo Explore Québec</strong>, vous acceptez les présentes conditions. 
                    Si vous n'êtes pas d'accord, veuillez ne pas utiliser ce site.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">2. Nature du service et Intelligence Artificielle</h2>
                <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200 text-sm">
                    <p><strong>AVERTISSEMENT IMPORTANT :</strong></p>
                    <p>
                        Ce site utilise une technologie d'intelligence artificielle (IA) pour générer des suggestions d'itinéraires et d'activités. 
                        Bien que nous visions la précision, <strong>l'IA peut commettre des erreurs (hallucinations)</strong>.
                    </p>
                </div>
                <p className="mt-2">
                    Vous reconnaissez que les informations (horaires, prix, adresses, ouverture) sont fournies à titre indicatif. 
                    Il est de votre responsabilité de vérifier ces informations directement auprès des établissements avant de vous déplacer.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">3. Limitation de responsabilité</h2>
                <p>
                    <strong>FORFEO INC.</strong> ne pourra être tenu responsable de tout dommage direct ou indirect résultant de l'utilisation de ce site, 
                    y compris, mais sans s'y limiter : fermeture d'un commerce suggéré, erreur de géolocalisation, ou insatisfaction concernant une activité recommandée.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">4. Liens externes et Réservations</h2>
                <p>
                    Forfeo Explore Québec agit comme un portail de découverte. Les réservations de forfaits s'effectuent sur notre plateforme partenaire <strong>Forfeo.com</strong> ou directement chez les commerçants. Nous ne sommes pas responsables des transactions effectuées hors de ce domaine.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">5. Propriété intellectuelle</h2>
                <p>
                    Tout le contenu (textes, logos, code, design), à l'exception des cartes (OpenStreetMap/Google) et des contenus générés par les utilisateurs, 
                    est la propriété exclusive de FORFEO INC.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold mb-3 text-blue-800">6. Juridiction</h2>
                <p>
                    Ces conditions sont régies par les lois de la province de <strong>Québec</strong> et les lois du Canada applicables. 
                    Tout litige sera soumis à la compétence exclusive des tribunaux du district judiciaire de Québec.
                </p>
            </section>

        </div>
      </main>

      <Footer />
    </div>
  );
}
